/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPassengerDataFileFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type PassengerDataFile, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /StagingPassengerData/InsertSelectedPassengerData
 */
export interface InsertSelectedPassengerDataRequestBuilder extends BaseRequestBuilder<InsertSelectedPassengerDataRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PassengerDataFile[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PassengerDataFile[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InsertSelectedPassengerDataRequestBuilderUriTemplate = "{+baseurl}/StagingPassengerData/InsertSelectedPassengerData";
/**
 * Metadata for all the requests in the request builder.
 */
export const InsertSelectedPassengerDataRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: InsertSelectedPassengerDataRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createPassengerDataFileFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
